export const NAME = 'entries';
